
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.375 3h1.281l.281.219s2.507 2.024 5 5.094S25 15.537 25 20.001c0 1.978-.333 4.263-1.938 6.063-1.369 1.535-3.592 2.567-6.938 2.844-.085.007-.163.025-.25.031-.283.028-.57.063-.875.063-.097 0-.186-.028-.281-.031-.139.002-.263.031-.406.031-3.265 0-5.674-1.113-7.188-2.781s-2.125-3.807-2.125-5.813c0-4.244 1.984-7.63 3.969-10.344s3.919-4.935 4.219-6.281zM14.5 5.5c-.868 1.866-2.366 3.645-3.906 5.75C8.702 13.836 7 16.784 7 20.406c0 1.595.508 3.237 1.625 4.469.238.262.514.493.813.719-.078-.193-.164-.391-.219-.594-.619-2.311.099-5.073 1.969-7.594l.938-1.281.75 1.406c.511.955 1.047 1.345 1.344 1.438s.424.063.719-.281c.589-.689 1.141-3.002.094-6.406l-.375-1.281h1.938l.281.344c.548.633 1.188 1.78 1.938 3.406s1.529 3.644 1.938 5.656c.358 1.761.476 3.535-.063 5.094.34-.241.632-.509.875-.781 1.13-1.267 1.438-2.963 1.438-4.719 0-3.669-2.272-7.509-4.625-10.406-1.705-2.099-3.067-3.383-3.875-4.094zm3.063 11.719c-.157 1.133-.503 2.089-1.094 2.781-.688.806-1.824 1.195-2.844.875-.551-.173-1.025-.508-1.469-.969-.903 1.704-1.324 3.385-1 4.594.392 1.464 1.431 2.428 3.594 2.5.086.003.16 0 .25 0 .345-.011.686-.037 1-.063.15-.018.303-.036.438-.063 1.21-.239 1.804-.811 2.188-1.594.511-1.044.519-2.681.156-4.469-.25-1.23-.756-2.418-1.219-3.594z"}})])
          )
        }
      }
    